interface PanelDescriptor
{
	header: HTMLElement[] | Array<JQuery<HTMLElement>>;
	body: HTMLElement[] | Array<JQuery<HTMLElement>>;
	context?: string;
	header_sticky?: boolean;
}

class Panel
{
	private element: HTMLElement;

	constructor(descriptor: PanelDescriptor)
	{
		this.element = document.createElement( 'div' );

		const headerDiv = document.createElement( 'div');
		const bodyDiv = document.createElement( 'div');

		$( this.element ).addClass( 'panel' );

		if ( descriptor.context )
		{
			$( this.element ).addClass( 'panel-' + descriptor.context );
		}
		else
		{
			$( this.element ).addClass( 'panel-default' );
		}

		if ( descriptor.header_sticky )
		{
			$( headerDiv ).css({position: 'sticky', top: '62px'});
		}

		$( this.element ).css('border-radius', '0px');

		if ( descriptor.header )
		{
			$( headerDiv ).addClass( 'panel-heading' );

			for ( const i in descriptor.header )
			{
				$( headerDiv ).append( descriptor.header[ i ] );
			}

			$( this.element ).append( headerDiv );
		}

		if ( descriptor.body )
		{
			$( bodyDiv ).addClass( 'panel-body' );

			for ( const i in descriptor.body )
			{
				$( bodyDiv ).append( descriptor.body[ i ] );
			}

			$( this.element ).append( bodyDiv );
		}
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
